import request from '@/utils/request'
import * as Payment from '@/interfaces/payment'
import { AxiosPromise } from 'axios'

export function payByCreditCard (data: Payment.ICreditCardPayRequest): AxiosPromise<any> {
  return request({
    url: '/128_CathayPayment.php',
    method: 'post',
    data
  })
}

export function getTxStatus (data: Payment.IGetTxStatusRequest): AxiosPromise<any> {
  return request({
    url: '/163_GetTxStatus_tok.php',
    method: 'post',
    data
  })
}

export function setTxCount (data: Payment.ISetTxCountRequest): AxiosPromise<any> {
  return request({
    url: '/165_SetTxCnt_tok.php',
    method: 'post',
    data
  })
}
